import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const ConnectedProjectIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 4C3.34315 4 2 5.34315 2 7V14.5C2 16.1569 3.34315 17.5 5 17.5H16.5C18.1569 17.5 19.5 16.1569 19.5 14.5V7C19.5 5.34315 18.1569 4 16.5 4H5ZM16.5 5.2H5C4.00589 5.2 3.2 6.00589 3.2 7V7.4H18.3V7C18.3 6.00589 17.4941 5.2 16.5 5.2ZM18.3 8.6H3.2V14.5C3.2 15.4941 4.00589 16.3 5 16.3H16.5C17.4941 16.3 18.3 15.4941 18.3 14.5V8.6Z"
				fill="#4C4C58"
			/>
			<path
				d="M21.4 8.30002C21.7314 8.30002 22 8.56865 22 8.90002V17C22 18.6569 20.6568 20 19 20H6.89999C6.56862 20 6.29999 19.7314 6.29999 19.4C6.29999 19.0687 6.56862 18.8 6.89999 18.8H19C19.9941 18.8 20.8 17.9941 20.8 17V8.90002C20.8 8.56865 21.0686 8.30002 21.4 8.30002Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

ConnectedProjectIcon.propTypes = iconPropTypes;
ConnectedProjectIcon.defaultProps = iconDefaultProps;
